import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  color: "text-grey",
  class: "subtitle-wrapper d-flex align-center justify-center pt-3 pb-3"
}
const _hoisted_2 = { class: "d-flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_DatePager = _resolveComponent("DatePager")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_app_bar, {
      color: "primary",
      flat: "",
      app: "",
      dark: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_app_bar_nav_icon, {
          style: {"position":"absolute"},
          onClick: _ctx.routerBack
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              large: "",
              color: "white"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("mdi-chevron-left", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_v_spacer),
        (_ctx.child && _ctx.clas)
          ? (_openBlock(), _createBlock(_component_v_app_bar_title, {
              key: 0,
              style: {"min-width":"fit-content"}
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString((_ctx.child.lastName + ' ' + _ctx.child.firstName + '（' + _ctx.clas.className + ' )').length > 14
            ? (_ctx.child.lastName + ' ' + _ctx.child.firstName + '（' + _ctx.clas.className + ' )').slice(0, 14) + '…' 
            : _ctx.child.lastName + ' ' + _ctx.child.firstName + '（' + _ctx.clas.className + ' )'), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, {
          color: "primary",
          variant: "flat",
          icon: "",
          onClick: _ctx.openSelectChildDialog,
          loading: _ctx.btnLoading,
          height: "40",
          width: "40"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { color: "white" }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode(" mdi-arrow-down-drop-circle-outline ", -1)
              ]))]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["onClick", "loading"])
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogFlg,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogFlg) = $event)),
      width: "280px",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "selectItemList pb-0" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.selectedClass,
                  "onUpdate:modelValue": [
                    _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedClass) = $event)),
                    _ctx.selectChildItems
                  ],
                  items: _ctx.classList,
                  "item-title": "className",
                  "item-value": "classId",
                  variant: "filled",
                  "hide-details": "",
                  "return-object": "",
                  color: "rgb(105,105,105)"
                }, null, 8, ["modelValue", "items", "onUpdate:modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, {
              style: {"height":"40vh"},
              class: "childList"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_list, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.childList, (c, index) => {
                      return (_openBlock(), _createBlock(_component_v_list_item, {
                        key: index,
                        onClick: ($event: any) => (_ctx.toClassChildrenRecords(c))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_list_item_title, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(c.name), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createElementVNode("div", {
      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.openDateDialog && _ctx.openDateDialog(...args)))
    }, [
      _createVNode(_component_DatePager, {
        date: _ctx.date,
        onAddDay: _ctx.addDay,
        onSubtractDay: _ctx.subtractDay
      }, null, 8, ["date", "onAddDay", "onSubtractDay"])
    ]),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('records.notSharedWithParents')), 1),
    _createVNode(_component_v_container, { class: "pa-2" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_textarea, {
          label: _ctx.$t('form.content'),
          modelValue: _ctx.content,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.content) = $event)),
          variant: "outlined",
          rows: "17",
          "hide-details": "",
          density: "compact",
          loading: _ctx.contentLoading
        }, null, 8, ["label", "modelValue", "loading"])
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_btn, {
        color: "primary",
        variant: "flat",
        onClick: _ctx.saveContent,
        loading: _ctx.btnLoading
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbar,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.snackbar) = $event)),
      timeout: _ctx.timeout,
      outlined: "",
      top: "",
      color: "primary"
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          color: "outline-primary",
          variant: "text",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.snackbar = false))
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode(" × ", -1)
          ]))]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.snackBarText) + " ", 1)
      ]),
      _: 1
    }, 8, ["modelValue", "timeout"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dateDialogFlg,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dateDialogFlg) = $event)),
      width: "auto",
      "max-width": "100%"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_date_picker, {
              modelValue: _ctx.selectedDate,
              "onUpdate:modelValue": [
                _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedDate) = $event)),
                _ctx.dateSelected
              ],
              type: "date",
              "day-format": (date) => new Date(date).getDate(),
              "no-title": "",
              "hide-header": "",
              color: "primary"
            }, null, 8, ["modelValue", "day-format", "onUpdate:modelValue"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}